import { combineReducers } from 'redux';
import { mvkDataReducer } from './mvk_data';
import { mvkStateReducer } from './mvk_state';
import { noopReducer } from './noopReducer';
export function createMainReducer() {
  return combineReducers({
    MVKData: mvkDataReducer,
    MVKState: mvkStateReducer,
    withInfrastructure: noopReducer(),
    mapApiKey: noopReducer()
  });
}